export async function prepareEmergencyImage(file: File): Promise<Blob> {
  const maxSide = 1600;
  const quality = 0.85;

  try {
    const objectUrl = URL.createObjectURL(file);
    try {
      const img = await loadImage(objectUrl);
      const scale = Math.min(1, maxSide / Math.max(img.width || 1, img.height || 1));
      const width = Math.max(1, Math.round((img.width || maxSide) * scale));
      const height = Math.max(1, Math.round((img.height || maxSide) * scale));

      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext("2d");
      if (!ctx) return file;
      ctx.drawImage(img, 0, 0, width, height);

      const blob = await new Promise<Blob | null>((resolve) => {
        canvas.toBlob((next) => resolve(next), "image/jpeg", quality);
      });
      return blob ?? file;
    } finally {
      URL.revokeObjectURL(objectUrl);
    }
  } catch {
    return file;
  }
}

function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error("Could not load image for upload"));
    img.src = src;
  });
}
